import { FunctionComponent, useContext, useEffect, useState } from 'react'
import { Box, useMediaQuery } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import gaiaTheme from '../../../root-components/theme'
import ProductComponentService from '../../../shared/services/product-component/product-component.service'
import { IProductComponent } from '../../../shared/services/product-component/product-component.model'
import { ProductComponentForm } from '../../presentation-components/product-components/product-component-form'
import ContactSupplierService from '../../../shared/services/contact-supplier/contact-supplier.service'
import { IContactSupplierDetails } from '../../../shared/services/contact-supplier/contact-supplier.model'
import { BackButtonLink } from '../../presentation-components/display-elements-components/back-button-link'
import { UserNotificationsContext } from '../../../context/user-notifications/user-notifications'

export const CreateNewProductComponentPage: FunctionComponent<{ isEditPage?: boolean }> = ({ isEditPage }) => {

  const navigate = useNavigate();
  const { id } = useParams();
  const userNotificationsContext = useContext(UserNotificationsContext)
  const productComponentService = new ProductComponentService();
  const contactSupplierService = ContactSupplierService.getInstance();
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
  const [productComponent, setProductComponent] = useState<IProductComponent>();
  const [contactSuppliers, setContactSuppliers] = useState<IContactSupplierDetails[]>([]);

  useEffect(() => {
    contactSupplierService.getActiveSuppliersLite(false)
      .then(response => {
        setContactSuppliers(response)
      })

    if (isEditPage && id) {
      productComponentService.getOne(id)
        .then(response => {
          setProductComponent(response)
        })
    }
  }, [])

  const onSubmit = (value: IProductComponent) => {
    if (isEditPage) {
      productComponentService.update(id!, value)
        .then(response => {
          navigate(`/products/component/${response.id}`)
          userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' })
        })
    } else {
      productComponentService.create(value)
        .then(response => {
          navigate(`/products/component/${response.id}`)
          userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' })
        })
    }
  }


  return (
    <Box sx={{ pb: isMobileMode ? 3 : 6, pl: isMobileMode ? 3 : 6, pr: isMobileMode ? 3 : 6, pt: isMobileMode ? 3 : 5, mt: isMobileMode ? 5 : 0, }}>
      <Box sx={{ mb: 1 }}>
        <BackButtonLink buttonText={!isEditPage ? 'Back to products components' : 'Back to product component'} link={!isEditPage ? `/products?tab=1` : `/products/component/${id}`} />
      </Box>
      {(!isEditPage || productComponent) && <ProductComponentForm
        onSubmit={onSubmit}
        productComponent={productComponent}
        isEditPage={!!isEditPage}
        constactSuppliers={contactSuppliers} />}
    </Box>
  )
}